export default __webpack_public_path__ + "static/media/building_materials.ceef24cc.jpg";